import { type QuestionType } from '@core/blocks/edu-flow/components/Page/types';
import { type MonarchEditableAsset, type AssetQuestionOption } from '@core/context/types';

const noPii = (
  question: QuestionType,
  {
    questionHeading,
    questionSubHeading,
    questionStepId,
    questionStepName,
    sidePanelContentHeading,
    sidePanelContentValue,
    preSubheading,
    callout,
  }: MonarchEditableAsset
): QuestionType => {
  // Start with question bank values
  const result = { ...question };

  // Override with Monarch values if provided
  result.heading = questionHeading || question.heading;
  result.postSubheading = questionSubHeading || question.postSubheading;
  result.stepId = questionStepId || question.stepId;
  result.stepName = questionStepName || question.stepName;
  result.preSubheading = preSubheading || question.preSubheading;

  if (result.fields) {
    const calloutField = result.fields.find((field) => field.name === 'callout');
    if (calloutField) {
      calloutField.content = callout || calloutField.content;
    }
  }

  // set the additional content
  if (result.additionalContent) {
    const infoPanelField = result.additionalContent.find((field) => field.name === 'infoPanel');

    if (infoPanelField) {
      infoPanelField.heading = sidePanelContentHeading || infoPanelField.heading;
      infoPanelField.content = sidePanelContentValue || infoPanelField.content;
    }
  }

  return result as QuestionType;
};

export default noPii;
